import React from "react";

// Simplified flags drawn inline: flag emoji do not render on Windows and the
// language controls should not pull in an image or an icon package.
export const UnitedStatesFlag = ({ className }) => (
  <svg className={className} viewBox="0 0 20 14" aria-hidden="true">
    <rect width="20" height="14" fill="#fff" />
    {[0, 2, 4, 6, 8, 10, 12].map(y => (
      <rect key={y} y={y * (14 / 13)} width="20" height={14 / 13} fill="#b22234" />
    ))}
    <rect width="8.5" height={7 * (14 / 13)} fill="#3c3b6e" />
    {[1.4, 3.3, 5.2, 7.1].map(x =>
      [1.3, 3.1, 4.9, 6.4].map(y => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="0.45" fill="#fff" />
      ))
    )}
  </svg>
);

export const SpainFlag = ({ className }) => (
  <svg className={className} viewBox="0 0 20 14" aria-hidden="true">
    <rect width="20" height="14" fill="#aa151b" />
    <rect y="3.5" width="20" height="7" fill="#f1bf00" />
  </svg>
);
